import axios from "axios";
import route from "ziggy-js";
import { useMutation, useQuery, useQueryClient } from "@tanstack/vue-query";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const validViews = ["table", "list", "kanban"];
const { maxSmall } = useBreakpoints();

const QUERY_KEY = ["user_preferences"];

async function fetchUserPreferences() {
    const { data: r } = await axios.get(route("api.preferences.all"));
    return r.data;
}

export function useUserPreferences(preference = null) {
    return useQuery({
        queryKey: QUERY_KEY,
        queryFn: fetchUserPreferences,
        refetchOnMount: true,
        select: (data) => {
            switch (preference) {
                case "task_view":
                    return maxSmall.value ? "list" : data.task_view ?? "table";
                case "task_tabs":
                    return (
                        data.task_tabs ?? {
                            collapsed: false,
                            selected: "activity",
                        }
                    );
                default:
                    return data;
            }
        },
    });
}

export function useUpdateTaskView() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (view) => {
            if (!validViews.includes(view)) {
                return Promise.reject(new Error(`Invalid task view: ${view}`));
            }
            return axios.patch(route("api.preferences.task-view.update"), {
                view,
            });
        },
        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: QUERY_KEY });
        },
    });
}

export function useUpdateTaskTabsState() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (state) => {
            return axios.patch(route("api.preferences.task-tabs.update"), {
                state,
            });
        },
        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: QUERY_KEY });
        },
    });
}
